import { List, Skeleton } from '@fs/zion-ui'
import React from 'react'

export function NotesSkeleton(): JSX.Element {
  return (
    <List>
      <Skeleton.ListItem hasSecondLine />
      <Skeleton.ListItem hasSecondLine />
      <Skeleton.ListItem hasSecondLine />
    </List>
  )
}
